import Dashboard from '@/lib/api/dashboard';
import Partners from '@/lib/api/partners';
import StoreFront from '@/lib/api/storefront';
import privateApi from '@/lib/client/private-instance';
import publicApi from '@/lib/client/public-instance';
import { AxiosInstance } from 'axios';

export interface APIOptions {
  hostname: string;
}

class API {
  public privateClient: AxiosInstance;
  public publicClient: AxiosInstance;

  public admin: Dashboard;
  public site: StoreFront;
  public partner: Partners;

  constructor() {
    this.privateClient = privateApi;
    this.publicClient = publicApi;

    this.admin = new Dashboard(this.privateClient);
    this.site = new StoreFront(this.publicClient);
    this.partner = new Partners(this.publicClient);
  }
}

export default API;
